var markdownInfo = {};

var nlInfo = {

"leerunit_mka":`
### Implementeren leerunit MKA
Op de meldkamer wordt een oefenopstelling voor de nieuwe centralisten gecreëerd en in gebruik genomen.
`,

"7510": `
### Certificering NEN 7510 
Informatie in de zorg vergt optimale beveiliging. In 2025 vindt hercertificering plaats. We trekken gezamenlijk op met andere RVE'en binnen Hecht.
`,

"ambulances": `
### Aanbesteding 27 ambulances
In 2024 zijn de voorbereidingen getroffen. Afronding en gunning vinden plaats in 2025.
`,

"telefonie": `
### Vervangen telefonie ambulances 
Onderzocht wordt of we de Zebra telefoons moeten vervangen of misschien een andere oplossing moeten zoeken.
`,

"geadviseerd": `
### Introductie geadviseerde uitgifte MKA
Seconds is een programma dat wordt geïntroduceerd op de MKA. De centralist wordt geholpen d.m.v. de software om op basis van AI een gefundeerde keuze te maken bij het spreiden van ambulances in geval van schaarste. 
`,

"spreidingextra": `
### Spreiding en beschikbaarheidstool inzetten ter verbetering prestaties
De S&B tool hebben we sinds 2024 in gebruik. De adviezen die we hieruit krijgen moeten we opvolgen in het belang van verbetering van prestaties.
`, 

"introductie": `
### Introductie planmodule B-vervoer MKA
Er komt een soort boekingssysteem voor ziekenhuizen en huisartsen, zodat de MKA meer wordt ontlast en de aanvrager een beter beeld heeft van de mogelijkheden voor het aanvragen van een ambulance.
`,

"roosterextra": `
### Nieuw roosterbeleid en roosterreglement opstellen
Een volgende stap die volgt op de introductie van InPlanning.
`,

"digicoach": `
### Digicoaches installeren
Technologie speelt een grotere rol in ons werk, met kansen en uitdagingen. Digicoaches helpen collega’s digitaal vaardiger te worden.
`,

"meerjarenhuis": `
### Ontwerpen meerjaren huisvestingsplan
In de komende jaren zullen we te maken krijgen met de vervanging en verplaatsing van posten. Wat gebeurt met Leiden is nog onzeker.
`,

"ontwerpen": `
### Ontwerpen strategisch voertuigen en duurzaamheid
In bredere zin moeten we nadenken over de aanschaf van nieuwe voertuigen, ook in relatie tot duurzaamheid.
`,

"pcot": `
### Introductie troponinemeting op de ambulance (POCT)
Het onderzoek met de troponinemeters komt in een volgende fase. De meters komen op al onze ambulances.
`,

"doorbouwen": `
### Doorbouwen op uitkomsten cultuurverbetertraject
Het verbetertraject heeft de nodige adviezen opgeleverd die deels zijn opgepakt in 2024. Omdat we vanaf 1 januari de capaciteit op orde hebben kan het operationeel management er verder mee aan de slag.
`,

"mentaal": `
### Programma mentale gezondheid uitwerken
Basis is in 2024 gelegd voor het programma. Dat moet nu worden geëffectueerd. 
`,

"bekwaam": `
### Bekwaamheidsbeleid implementeren
Beleid is vastgesteld in 2024 en moet in 2025 geconcretiseerd worden. Heeft o.a. te maken met het minimaal aantal uren werkervaring per week.
`,

"nieuwegein": `
### Verplaatsing post Nieuwveen
Nieuwveen ligt niet ideaal. Als we de andere post in Alphen gaan verplaatsen is een voorwaarde dat deze post een betere plek gaat krijgen.
`,

"uitzend": `
### Terugdringen inhuur uitzendkrachten
We geven te veel geld uit aan uitzendkrachten. Dat moet minder worden door beter plannen en weloverwogen keuzes maken over uitval van diensten.
`,

"vink": `
### Implementeren leermanagementsysteem
Het LMS moet een plek gaan krijgen.
`,

"pion": `
### Ontwikkelen capaciteitsplanning
Wat we nu doen met de planning is reactief. We willen meer pro-actief werken als het gaat om het plannen van de capaciteit.
`,

"smart": `
### SMART-triage ontwikkelen in de keten
In 2025 wordt het SMART-triage traject verder doorlopen.
`,

"data": `
### Datagedreven werken introduceren
We hebben heel veel data. Daar moeten we bruikbare informatie van maken, die we op verschillende plekken in de organisatie kunnen raadplegen.
`,

"coordinatie": `
### Zorgcoördinatie intensiveren Juiste Zorg Juiste Plek
Dit betreft de trajecten van Transmuralis en Gedeelde Zorg.
`,

"meerjarenopstellen": `
### Meerjaren opleidingsplan opstellen
Is uitgesteld en moet dus nu worden opgepakt.
`,

"tennis": `
### Beleid vitaliteit & duurzame inzetbaarheid verder vorm geven
Beleid is in 2024 geformuleerd en deels in gang gezet. Dit moet in 2025 een vervolg gaan krijgen.
`,

"paa": `
### PAA/ VSA bestendigen in organisatie
De PA en VS Ambulancezorg moeten een vaste plek gaan krijgen in de optimalisatie van de verschillende zorgniveaus die we bieden. Hier moeten keuzes in genomen worden.
`,

"gouda": `
### Oriëntatie huisvesting Gouda
Post Gouda wordt te klein. In principe is de plek van de post niet verkeerd. Er komt misschien een mogelijkheid om uit te breiden op de zelfde plek.
`,

"doorontwikkel": `
### Doorontwikkelen roostersystematiek
InPlanning biedt de mogelijkheid tot Samenroosteren. Onderzocht gaat worden of dit het juiste middel is om het rooster langs te maken. In 2025 zullen we een pilot gaan doen.  
`,

"paraat": `
### Implementeren paraatheidsbeleid 
Operationeel management heeft behoefte aan een handelingsperspectief voor het omgaan met de korte termijn roosterproblemen. Dat moet worden vastgelegd.
`

};


export var markdownInfo = nlInfo;

